import { fetchAuthSession } from 'aws-amplify/auth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://oauth.remote-assistant.ai';

class PhoneNumberService {
  async getAuthToken() {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString() || session.tokens?.accessToken?.toString();
      if (!token) {
        throw new Error('No valid token found');
      }
      return token;
    } catch (error) {
      console.error('Auth token error:', error);
      throw new Error('Authentication required');
    }
  }

  async getAvailablePhoneNumbers(searchParams = {}) {
    const token = await this.getAuthToken();
    
    const { areaCode, country = 'US', region, locality, postalCode, limit = 3 } = searchParams;
    

    // Build query parameters
    const params = new URLSearchParams();
    if (areaCode) params.append('area_code', areaCode);
    params.append('country', country);
    if (region) params.append('region', region);
    if (locality) params.append('locality', locality);
    if (postalCode) params.append('postal_code', postalCode);
    params.append('limit', limit.toString());
    
    const response = await fetch(`${API_BASE_URL}/oauth/phone-numbers/available?${params.toString()}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error(`Phone numbers API error (${response.status}):`, errorText);
      
      if (response.status === 401) {
        throw new Error('Please sign in again to load phone numbers');
      }
      if (response.status === 404) {
        throw new Error('Phone numbers service not found');
      }
      throw new Error(`Failed to load phone numbers (${response.status}): ${errorText}`);
    }

    const data = await response.json();

    // Handle different possible response formats
    if (data.numbers) {
      return { phone_numbers: data.numbers };
    } else if (data.phone_numbers) {
      return data;
    } else if (Array.isArray(data)) {
      return { phone_numbers: data };
    } else {
      console.warn('Unexpected API response format:', data);
      return { phone_numbers: [] };
    }
  }

  async getUserPhoneNumbers() {
    const token = await this.getAuthToken();
    
    const response = await fetch(`${API_BASE_URL}/oauth/phone-numbers/user`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error(`Get user phone numbers error (${response.status}):`, errorText);
      
      if (response.status === 401) {
        throw new Error('Please sign in again');
      }
      if (response.status === 404) {
        return { numbers: [] }; // No numbers found
      }
      throw new Error(`Failed to get user phone numbers (${response.status}): ${errorText}`);
    }

    return await response.json();
  }
}

export const phoneNumberService = new PhoneNumberService();
export default phoneNumberService;